import React from 'react';
import DefaultLayout from '../../layouts/default';
import Overview from './components/overview';
import Stats from './components/stats';
import TemperatureStatusOverview from './components/temperatureStatusOverview';
import TemperatureTrend from './components/temperatureTrend';
import Aisummary from './components/Aisummary';
import AlertCard from './components/AlertsCard';
import { TemperatureProvider } from './context/TemperatureContext';

function DashboardPage() {

  return (
    <TemperatureProvider>
    <DefaultLayout>
        <Overview />
        <Stats />
        <TemperatureStatusOverview />
        <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <TemperatureTrend />
          <Aisummary />
          <AlertCard />
        </section>
    </DefaultLayout>
    </TemperatureProvider>
  );
}

export default DashboardPage;
